import * as Zlib from 'zlib';

const styles = {

  fullWidth: {
    width: "100%",
  },

  logoLogin: {
    // position:"absolute",
    textAlign: "center",
    // marginLeft:30,
    marginBottom: 15,
  },

  backLogin: {
    position: "absolute",
    marginTop: 45,
    marginLeft: 40,
    marginBottom: 15,
    zIndex: 999,
  },

  headerAppBarStyle: {
    position: "absolute",
    margin: 0,
    paddingTop: 45,
    paddingRight: 120,
    right: 0,
    left: 0,
    // width: "40%",
    backgroundColor: "#FFF",
  },
  footerText: {
    fontSize: 15,
    textAlign: "center",
    color: "#ffffff",
  },
  //
  mailformat: {
    textTransform: "capitalize",
  },

};

export default styles;
